import ApplicationSerializer from 'eflex/serializers/application';

export default class AuditSerializer extends ApplicationSerializer {
  attrs = {
    metadata: {
      embedded: 'always',
    },
  };
}
